import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const state = {
  masters: null,
};

export const mutations = {
  SET_MASTERS(state, newValue) {
    state.masters = Object.assign({}, state.masters, newValue);
  },
};

export const actions = {
  async getMasters({ state, commit }, payload) {
    // check masters on state
    const masters = (state.masters && Object.keys(state.masters)) || [];
    const mastersRequest = (payload.name && Object.values(payload.name)) || [];
    const excludeCache = ['kota', 'kecamatan', 'kelurahan'];
    const mastersForRequest = payload.always
      ? mastersRequest
      : mastersRequest.filter((item) => excludeCache.includes(item) || masters.indexOf(item) === -1);
    const indexMasterForRequest = mastersForRequest.map((item) => mastersRequest.indexOf(item));

    if (indexMasterForRequest && indexMasterForRequest.length) {
      // buat params baru
      let params = {};
      for (const key in payload) {
        params[key] = {};
        indexMasterForRequest.forEach((item, index) => {
          if (payload[key] && payload[key][item]) params[key][index] = payload[key][item];
        });
      }

      const data = await http.get(`/master?${queryString(params)}`).then(({ data }) => data);
      commit('SET_MASTERS', data);
    }

    return state.masters;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
